"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var react_i18next_1 = require("react-i18next");
var defaultStyle = { fontSize: 52, color: '#FF3700' };
var Loading = function (props) {
    var message = props.message, style = props.style, loading = props.loading, children = props.children;
    var t = react_i18next_1.useTranslation().t;
    var tip = message && t(message);
    var antIcon = react_1.default.createElement(antd_1.Icon, { type: "loading", style: style || defaultStyle, spin: true });
    return (react_1.default.createElement("div", { className: "ant-app-loading" },
        react_1.default.createElement(antd_1.Spin, { indicator: antIcon, tip: tip, spinning: loading }, children)));
};
exports.default = Loading;
